// extracted by mini-css-extract-plugin
export default {"item":"LanguageSwitcher_item__JbW11","active":"LanguageSwitcher_active__ftPZa"};